import styled from '@emotion/styled';
import * as React from 'react';
import { SCROLL } from '../scroll';

export interface ScrollableContainerProps {
  showScrollbar?: boolean;
  scrollableRef?: React.RefObject<HTMLDivElement>;
}

export const ScrollableContainer: React.FC<React.PropsWithChildren<ScrollableContainerProps>> = (props) => {
  const { children, showScrollbar = true } = props;
  return (
    <S.Container>
      <S.Scroller ref={props.scrollableRef} showScrollbar={showScrollbar}>
        {children}
      </S.Scroller>
    </S.Container>
  );
};

namespace S {
  export const Container = styled.div`
    flex-grow: 1;
    flex-shrink: 1;
    overflow: hidden;
    display: flex;
  `;

  export const Scroller = styled.div<{ showScrollbar: boolean }>`
    flex-grow: 1;
    overflow: auto;
    position: relative;
    overscroll-behavior: contain;
    overflow-x: hidden;
    ${(p) => SCROLL(p.theme, p.showScrollbar)};
    display: flex;
    flex-direction: column;
  `;
}
